import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { Button } from 'antd';
import { createSonarSelector } from '@lib/selectors';
import { DailySyncToggle } from './DailySyncToggle';
import { importsActions } from '@sonar-software/sonar-imports';
import { LastSyncSummary } from './LastSyncSummary';
import { PardotSync } from './PardotSync';
import { SonarCard } from '@ui/general';
import { useNavigate } from 'react-router-dom';
import { When } from 'react-if';

import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useAmplitude, useOnMount, useSonarSelector } from '@hooks';

const hasImportsSelector = createSonarSelector((state) => (state?.imports?.latest?.get?.data?.length ?? 0) > 0);

export const SalesForceSummary: React.FC = () => {
	const navigate = useNavigate();
	const logEvent = useAmplitude();
	const anyImports = useSonarSelector(hasImportsSelector);

	const requestGetImportsLatestAction = useAction(importsActions.requestGetImportsLatest);

	useOnMount(() => {
		requestGetImportsLatestAction({});
	});

	const handleClick = useCallback(() => {
		logEvent(AMPLITUDE_EVENT.VIEW_DIFFERENCES_CLICKED);
		navigate(FULL_ROUTES.TIMELINE);
	}, [ logEvent, navigate ]);

	const lastSyncSummaryText = `${COPY_SPECIFIC.LAST_SYNC_SUMMARY}`;

	return (
		<SonarCard
			className='salesforce-summary'
			extra={
				<When condition={ anyImports }>
					<Button
						id='view-detailed-changes-button'
						onClick={ handleClick }>
						{ COPY_SPECIFIC.VIEW_DETAILED_CHANGES }
					</Button>
				</When>
			}
			title={
				<>
					<span className='h2'>{ lastSyncSummaryText }</span>
					<PardotSync />
				</>
			}>
			<LastSyncSummary />
			<DailySyncToggle />
		</SonarCard>
	);
};
